import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

const DeleteConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "Confirm Deletion",
  message = "Are you sure you want to delete this item?",
  itemName = "",
  loading = false
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">{title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="mb-6">
          <div className="flex items-start gap-3 mb-4">
            <AlertTriangle className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-gray-700">{message}</p>
              {itemName && (
                <p className="mt-2 font-semibold text-gray-900">{itemName}</p>
              )}
            </div>
          </div>
          <p className="text-sm text-red-600">This action cannot be undone.</p>
        </div>

        <div className="flex gap-3">
          <Button 
            type="button" 
            variant="outline" 
            onClick={onClose} 
            className="flex-1"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            type="button" 
            onClick={onConfirm} 
            className="flex-1 bg-red-600 hover:bg-red-700"
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
